/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Address_MinInputs */

const vi_validation_address_min = /** @type {(inputs: Validation_Address_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ phải có ít nhất 5 ký tự`)
};

/**

* @param {Validation_Address_MinInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const validation_address_min = /** @type {((inputs?: Validation_Address_MinInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Address_MinInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_validation_address_min(inputs)
});